module.exports = __webpack_public_path__ + "img/recommen-img3.4d6acf16.png";